import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, BellOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const NotificacoesFiliais = () => {
  const { id_notificacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS PERFIl
  const [notificacao, setNotificacao] = useState({});

  useEffect(() => {
    if (id_notificacao) {
      carregarNotificacao(id_notificacao);
      listarFiliais(id_notificacao);
    }
  }, [id_notificacao]);

  // CARREGAR NOTIFICAÇÃO
  const carregarNotificacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/notificacoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/notificacoes/cadastro");
      }

      setNotificacao(api.response.data);
    } else {
      navigate("/notificacoes/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarFiliais = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/notificacoes_filiais/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      navigate("/notificacoes/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarFiliais = async (filiais_selected, filiais, id) => {
    setLoading(true);

    let array_filiais = [];
    filiais?.map((e) => {
      array_filiais.push(e.key);
    });

    const dados_envio = {
      id_cad_notificacoes: id,
      id_notificacoes_filiais: array_filiais,
      id_notificacoes_filiais_checked: filiais_selected,
    };

    const api = await http("post", `v1/notificacoes_filiais/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_filiais.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...filiais_selected]);
    } else {
      navigate("/notificacoes/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Filial <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "filial",
      sorter: (a, b) => a.filial?.localeCompare(b.filial),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.filial?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarFiliais(array, dadosFilter, id_notificacao);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarFiliais(status ? [data.key] : [], [{ key: data.key }], id_notificacao);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate("/notificacoes/cadastro")} />
            <HeaderTitle
              title="Notificacão Filiais"
              subtitle={
                <Text italic>
                  <BellOutlined /> {notificacao?.descricao ?? ""}
                </Text>
              }
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
